import { connect } from "react-redux";
import GenerateAudio from "../../Components/GenericComponent/GenerateAudio";

const mapStateToProps = (state) => ({
    medias:state.reducer.MEDIAS,
  

});
const mapDispatchToProps = (dispatch) => ({
  
});
 
export default connect(mapStateToProps, mapDispatchToProps)(GenerateAudio);